/**
 * 会社マスタ(グループ会社対応・要件定義書 1.5)。
 * 取引と口座は company_id を持つ。入力時の初期値は SUM。
 */
import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  setDoc,
  updateDoc,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';
import { getDb } from '@core/lib/firebase';
import { DEFAULT_COMPANY_ID, type Company } from '@core/lib/types';

const COLLECTION = 'companies';

function withId(snap: QueryDocumentSnapshot): Company {
  return { id: snap.id, ...(snap.data() as object) } as Company;
}

export async function fetchCompanies(): Promise<Company[]> {
  const snap = await getDocs(query(collection(getDb(), COLLECTION), orderBy('display_order')));
  return snap.docs.map(withId);
}

/** 入力の初期値に使う会社。is_default が無ければ SUM、それも無ければ先頭 */
export function defaultCompany(companies: Company[]): Company | undefined {
  return (
    companies.find((c) => c.is_default && c.active) ??
    companies.find((c) => c.id === DEFAULT_COMPANY_ID) ??
    companies.find((c) => c.active)
  );
}

export async function upsertCompany(company: Company): Promise<void> {
  const { id, ...rest } = company;
  if (!id.trim() || !company.name.trim()) throw new Error('IDと会社名は必須です');
  await setDoc(doc(getDb(), COLLECTION, id.trim()), rest, { merge: true });
}

export async function setCompanyActive(id: string, active: boolean): Promise<void> {
  await updateDoc(doc(getDb(), COLLECTION, id), { active });
}
